module.exports = __webpack_public_path__ + "img/muneco.62b1650c.png";